import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  raw: defineAsyncComponent(() => import("/app/layouts/raw.vue").then(m => m.default || m))
}